import { render, staticRenderFns } from "./SupportEmptyStateIllustration.vue?vue&type=template&id=9b92e44c&scoped=true"
import script from "./SupportEmptyStateIllustration.vue?vue&type=script&lang=js"
export * from "./SupportEmptyStateIllustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b92e44c",
  null
  
)

export default component.exports